// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__v39iJ","sectionImage":"Card_sectionImage__JAgep","elementPrice":"Card_elementPrice__M3WcI"};